export const UPDATE_USER = "UPDATE_USER";
export const REMOVE_USER = "REMOVE_USER";
export const UPDATE_USER_VALUE = "UPDATE_USER_VALUE";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const REMOVE_CLIENT = "REMOVE_CLIENT";
export const UPDATE_CLIENT_VALUE = "UPDATE_CLIENT_VALUE";
export const PASSWORD_MISSMATCH = "password and password confirmation mismatch";
